import * as React from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import {
  deleteItem,
  insertItem,
  updateItem,
  getFieldTypeId,
} from "./workgrid-util";
import { CommandCell } from "./command-cell";
import FluentUiIcon from "../../../../../assets/fluent-ui-icon";
import "./workflow-grid.scss";
import { useLocation } from "react-router-dom";
import {
  GetWorkflowConditions,
  UpdateWorkflowConditions,
} from "../../../../../services/api/workflow-api";
import { DropDownCell } from "./dropdown-cell";
import { DropDownCellType } from "./dropdown-cell-type";
import { TextboxCell } from "./textbox-cell";
import { FluentButton } from "../../../../../components/FluentUI/Fluent-Button";
import { filterBy } from "@progress/kendo-data-query";
import PropTypes from "prop-types";

const editField = "inEdit";
const list = {
  WorkflowStatuses: {},
  DynamicForms: {},
  DynamicFields: {},
  Conditions: {},
  // prettier-ignore
  Available:{true:"Yes",false:"No"},
  // prettier-ignore
  Hidden:{true:"Yes",false:"No"},
};
const initialFilter = {
  logic: "and",
  filters: [],
};

export const WorkflowGridLegacy = (props) => {
  let location = useLocation();
  const [conditions, setConditions] = React.useState({
    isLoading: true,
    data: [],
  });
  const currentRowRef = React.useRef(null);
  const [isFullScreen, setIsFullScreen] = React.useState(false);
  const [filter, setFilter] = React.useState(initialFilter);

  const getWorkflowConditions = async () => {
    const wId = location.pathname.split("/").pop();
    const response = await GetWorkflowConditions(
      wId,
      props.workflowStatusId,
      props.type
    );

    setConditions((prevState) => ({
      ...prevState,
      data: response?.data?.WorkflowStatusConditions,
      isLoading: false,
    }));

    list.WorkflowStatuses = response?.data?.WorkflowStatuses;
    list.DynamicForms = response?.data?.DynamicForms;
    list.DynamicFields = response?.data?.DynamicFields;
    list.Conditions = response?.data?.Conditions;
  };

  const updateWorkflowConditions = async (updatedData) => {
    const wId = location.pathname.split("/").pop();
    const response = await UpdateWorkflowConditions(
      wId,
      props.workflowStatusId,
      updatedData,
      props.type
    );

    if (response.status === 200) {
      getWorkflowConditions();
    }
  };

  React.useEffect(() => {
    getWorkflowConditions();
  }, []);

  const ReCreateDropdown = (props) => {
    return React.createElement(DropDownCell, { ...props, list });
  };

  const ReCreateDropdownType = (props) => {
    return React.createElement(DropDownCellType, { ...props, list });
  };

  const ReCreateTextbox = (props) => {
    return React.createElement(TextboxCell, { ...props, list });
  };

  const remove = (dataItem) => {
    const newData = JSON.parse(JSON.stringify(conditions?.data));
    const updatedData = [...deleteItem(newData, dataItem)];
    currentRowRef.current = null;

    updateWorkflowConditions(updatedData);
  };

  const add = () => {
    const newData = JSON.parse(JSON.stringify(conditions?.data));
    const updatedData = insertItem(newData, currentRowRef.current);
    currentRowRef.current = null;

    updateWorkflowConditions(updatedData);
  };

  const update = () => {
    const newData = JSON.parse(JSON.stringify(conditions?.data));
    const updatedData = updateItem(newData, currentRowRef.current);
    currentRowRef.current = null;

    updateWorkflowConditions(updatedData);
  };

  const discard = () => {
    const newData = JSON.parse(JSON.stringify(conditions?.data));
    newData.shift();
    currentRowRef.current = null;

    setConditions((prevState) => ({
      ...prevState,
      data: newData,
    }));
  };

  const cancel = (dataItem) => {
    const newData = JSON.parse(JSON.stringify(conditions?.data));
    const originalItem = newData?.find((p) => p.Id === dataItem.Id);
    originalItem.inEdit = false;
    currentRowRef.current = null;

    setConditions((prevState) => ({
      ...prevState,
      data: newData,
    }));
  };

  const enterEdit = (dataItem) => {
    const newData = JSON.parse(JSON.stringify(conditions?.data));
    const originalItem = newData?.find((p) => p.Id === dataItem.Id);
    originalItem.inEdit = true;

    currentRowRef.current = JSON.parse(JSON.stringify(originalItem));

    setConditions((prevState) => ({
      ...prevState,
      data: newData,
    }));
  };

  const itemChange = (event) => {
    if (event.value === null) return;

    if (typeof event?.value === "object") {
      if (event.field === "IsAvailable" || event.field === "IsHidden") {
        currentRowRef.current[event.field] = event?.value?.id === "true";
      } else {
        currentRowRef.current[event.field] = event?.value?.text;
        currentRowRef.current[getFieldTypeId(event.field)] = event?.value?.id;
      }
    } else {
      currentRowRef.current[event.field] = event.value;
    }
  };

  const addNew = () => {
    if (currentRowRef.current === null) {
      const newDataItem = {
        inEdit: true,
        Id: null,
        WorkflowStatusId: null,
        WorkflowStatusName: null,
        DynamicFormId: null,
        DynamicFormName: null,
        DynamicFormStatus: null,
        DynamicFieldId: null,
        DynamicFieldName: null,
        ConditionType: null,
        ConditionValue: null,
        IsAvailable: null,
        IsHidden: null,
      };
      currentRowRef.current = JSON.parse(JSON.stringify(newDataItem));

      setConditions((prevState) => ({
        ...prevState,
        data: [newDataItem, ...prevState.data],
      }));
    }
  };

  return (
    !conditions?.isLoading && (
      <div className={isFullScreen ? "fullscreen-grid-workflow workflow-tables" : "workflow-tables"}>
        <div className={isFullScreen ? "mt-2 top-actions" : "top-actions"}>
          <div className="workflow-modal-description-title mt-3">{props.name}</div>
          <div className="bottom">
            <FluentButton
              icon={
                <FluentUiIcon
                  name={
                    isFullScreen
                      ? "FullScreenMinimizeFilled"
                      : "FullScreenMaximizeFilled"
                  }
                  color={"#212121"}
                  size={18}
                />
              }
              onClick={() => {
                setIsFullScreen((fc) => !fc);
              }}
            />
            <FluentButton
              icon={
                <FluentUiIcon name={"AddRegular"} color={"#212121"} size={20} />
              }
              onClick={addNew}
              text={"Add New"}
              className={"add-new-button"}
            />
          </div>
        </div>
        <div className="workflow-grid">
          <Grid
            onItemChange={itemChange}
            editField={editField}
            data={filterBy(conditions?.data, filter)}
            navigatable={true}
            filterable={true}
            filter={filter}
            onFilterChange={(e) => setFilter(e.filter)}
            resizable={true}
          >
            {/* <Column
              field="WorkflowStatusName"
              title="Workflow Status"
              cell={ReCreateDropdown}
            />
            <Column
              field="WorkflowStatusDescription"
              title="Workflow Status Description"
              editable={false}
            /> */}
            {(props.type === "form" ||
              props.type === "form-visibility" ||
              props.type === "form-availability") && (
              <Column
                field="DynamicFormName"
                title="Form"
                cell={ReCreateDropdown}
              />
            )}
            {props.type === "field" && (
              <Column
                field="DynamicFieldName"
                title="Field"
                cell={ReCreateDropdown}
              />
            )}
            <Column
              field="ConditionType"
              title="Type"
              cell={props.type === "field" ? ReCreateTextbox : ReCreateDropdownType}
            />
            {props.type === "field" && (
              <Column
                field="ConditionValue"
                title="Value"
                cell={ReCreateTextbox}
              />
            )}
            {props.type === "field" && (
              <Column
                field="IsAvailable"
                title="Available"
                filterable={false}
                cell={ReCreateDropdown}
              />
            )}
            {props.type === "form" && (
              <Column
                field="IsHidden"
                filterable={false}
                title="Hidden"
                cell={ReCreateDropdown}
              />
            )}
            <Column
              filterable={false}
              cell={(props) => (
                <CommandCell
                  {...props}
                  {...{
                    edit: enterEdit,
                    remove: remove,
                    add: add,
                    discard: discard,
                    update: update,
                    cancel: cancel,
                    editField: editField,
                  }}
                />
              )}
            />
          </Grid>
        </div>
      </div>
    )
  );
};

WorkflowGridLegacy.propTypes = {
  workflowStatusId: PropTypes.number,
};
